define([
	"dojo/_base/declare",
	"csi/table/Widget",
	"Apparel/StructureItemMixin",
], function(declare,Widget,StructureItemMixin) {

	return declare([Widget, StructureItemMixin], {
		/**
		 *  summary: remove "Mass Create SKUs" action from tool bar if view node is not a Collection type
		 *  and resolve view path and/or filters
		 */
		_resolveView: function() {
			if (this.getViewNodeType() != "Collection") {
				var tb = this.defView.defToolbar;
				if (tb) {
					tb.removeAction("MassCreateSKUs");
				}
			}
			this._resolveViewPath(this);
			this._resolveViewFilter(this);
			this.inherited(arguments);
		},
	});
});